import React from 'react';
import {Button} from 'epic-diesel-common';
import PropTypes from 'prop-types';
import styles from './Login.pcss';
import {navigateToSignin} from '../../utils/Utils';

class Login extends React.Component {
    static propTypes = {
        isLoggedIn: PropTypes.bool,
        children: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
    };

    render() {
        const {isLoggedIn} = this.props;
        if (isLoggedIn) {
            return this.props.children;
        }
        return (
            <div className={styles.container}>
                <div className={styles.title}>No Profile Data Loaded,</div>
                <div className={styles.content}>
                    <span>Oops! Looks like you are not signed in. Sign in to your epic</span>
                    <br />
                    <span>account to see your influencer earnings and settings</span>
                </div>
                <div className={styles.login}>
                    <Button onClick={navigateToSignin}>SIGN IN</Button>
                </div>
            </div>
        );
    }
}

export default Login;
